export default __webpack_public_path__ + "static/media/project_cienpotencia_blur.6a16861f.png";